import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import styles from './EngineDressingSequence.module.css';
import { Table, BackButton, DropToolBar } from '../../components';

function EngineDressingSequence({
  setSequenceCount,
  rowsData,
  lastRefreshedDate,
  selectedDate,
  setSelectedDate,
  hasActiveEdits,
  setHasActiveEdits,
  agsnDates,
}) {
  const history = useHistory();
  const ROW_HEIGHT = 40;

  const columns = [
    {
      title: 'Chassis ASN',
      field: 'chassisAsn',
      width: 150,
      enableSearch: true,
      enableFilter: true,
    },
    {
      title: 'Engine ASN',
      field: 'engineAsn',
      width: 150,
      enableSearch: true,
      enableFilter: true,
    },
    {
      title: 'Production Sequence',
      field: 'productionSequenceNumber',
      width: 100,
      enableSearch: true,
      enableFilter: true,
    },
    {
      title: 'Engine Line',
      field: 'engineLine',
      width: 120,
      enableSearch: true,
      enableFilter: true,
    },
    {
      title: 'Engine Part',
      field: 'enginePart',
      width: 180,
      enableSearch: true,
      enableFilter: true,
    },
    {
      title: 'GB Part',
      field: 'gbPart',
      width: 180,
      enableSearch: true,
      enableFilter: true,
    },
    {
      title: 'Engine Status',
      field: 'engineStatus',
      width: 150,
      enableSearch: true,
      enableFilter: true,
    },
    {
      title: 'Chassis Status',
      field: 'chassisStatus',
      width: 150,
      enableSearch: true,
      enableFilter: true,
    },
    {
      title: 'Drop Timestamp',
      field: 'dropTimestamp',
      width: 180,
      render: row =>
        row.dropTimestamp
          ? moment(row.dropTimestamp).format('DD-MM-YYYY HH:mm')
          : '-',
    },
    {
      title: 'Revised FDT',
      field: 'revisedFdt',
      width: 180,
      render: row =>
        row.revisedFdt
          ? moment(row.revisedFdt).format('DD-MM-YYYY HH:mm')
          : '-',
    },
  ];

  return (
    <>
      <div className={styles.backButton}>
        <BackButton
          basePath="engine"
          action="Engine Dressing Sequence"
          handleClick={() => history.push('/')}
        />
      </div>
      <DropToolBar
        activeDate={selectedDate}
        dates={agsnDates}
        handleDateSelect={date => setSelectedDate(date)}
        lastRefreshedDate={lastRefreshedDate}
       
        restrictNavigationDuringEditing={false}
        hasActiveEdits={hasActiveEdits}
        showAggregateLines
      />
      <div className={styles.container}>
        <div className={styles.tableView} style={{ height: '100%' }}>
          <Table
            columns={columns}
            defaultColumns={columns}
            rowHeight={ROW_HEIGHT}
            rows={rowsData.data || []}
            isDataLoading={rowsData.loading}
            displayHash
            hideCheckbox
            setHasActiveEdits={setHasActiveEdits}
            setAsnCount={count => setSequenceCount(count)}
          />
        </div>
      </div>
    </>
  );
}

EngineDressingSequence.propTypes = {
  setSequenceCount: PropTypes.func.isRequired,
  rowsData: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    filteredData: PropTypes.array.isRequired,
  }).isRequired,
  lastRefreshedDate: PropTypes.objectOf(moment),
  selectedDate: PropTypes.objectOf(moment).isRequired,
  setSelectedDate: PropTypes.func.isRequired,
  hasActiveEdits: PropTypes.bool.isRequired,
  setHasActiveEdits: PropTypes.func.isRequired,
  agsnDates: PropTypes.array.isRequired,
};

export default EngineDressingSequence;